import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { AxiosError } from 'axios';
import { showSnackbar } from '../../../api/snackbarSlice';
import { listConnectors } from './connectorsApi';

export const useGetConnectorsHandler = () => {
  const dispatch = useDispatch();

  const query = useQuery({
    queryKey: ['connectors'],
    queryFn: listConnectors,
  });

  useEffect(() => {
    if (!query.isError) {
      return;
    }

    const message =
      query.error instanceof AxiosError
        ? query.error.response?.data?.error || query.error.message
        : 'Failed to load connectors';

    dispatch(showSnackbar({ message, severity: 'error' }));
  }, [dispatch, query.error, query.isError]);

  return {
    connectors: query.data || [],
    isLoading: query.isLoading,
    refetch: query.refetch,
  };
};
